/**
 * Format an ISO timestamp for display in the 版本信息 dialog.
 *
 * Inputs are always strings (from the typed API). We never expose raw `Date`
 * objects to the renderer because they serialize differently across
 * environments and break snapshot tests.
 *
 * Falsy or unparseable values render as 未知 so the dialog never shows
 * a misleading "Invalid Date" or epoch fallback.
 */
export function formatVersionTime(value: string | null | undefined): string {
  if (typeof value !== 'string' || value.trim().length === 0) return '未知';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '未知';
  return parsed.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
}
